import { IDataProxy } from "./types";
import { ajax } from "./ajax";

export class DataProxy implements IDataProxy {
	public url: string;
	public config: any;

	protected _url: string;

	constructor(url: string, config?: any) {
		this.url = this._url = url;
		this.config = config;
	}

	updateUrl(url?: string, params: any = {}) {
		this._url = this.url = url || this._url;

		this.url += this.url.includes("?") ? "&" : "?";
		for (const param in params) {
			this.config[param] = params[param];
			this.url += `${param}=${encodeURIComponent(params[param])}&`;
		}
		this.url = this.url.slice(0, -1);
	}

	load<T = string>(): Promise<T> {
		return ajax.get(this.url, null, { responseType: "text" });
	}

	save(data: any, mode: string): Promise<any> {
		switch (mode) {
			case "delete":
				return ajax.delete(this.url, data);
			case "update":
				return ajax.put(this.url, data);
			case "insert":
			default:
				return ajax.post(this.url, data);
		}
	}
}
